import { render, staticRenderFns } from "./carboncredit.vue?vue&type=template&id=1b071b27&scoped=true&"
import script from "./carboncredit.vue?vue&type=script&lang=js&"
export * from "./carboncredit.vue?vue&type=script&lang=js&"
import style0 from "./carboncredit.vue?vue&type=style&index=0&id=1b071b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b071b27",
  null
  
)

export default component.exports